// warning-banner.js — Warning Banner state machine (BD §2.2 + §H3)
//
// state: 'visible' | 'dismissed'
// Tab 3 (info) → auto-hide (无论 dismissed 状态)
// Black Paper → show pairing-notice

(function () {
  var STORAGE_KEY = 'sticker_warning_dismissed';
  var BLACK_PAPER_VALUE = 'black';

  function whenReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  whenReady(function () {
    var banner = document.getElementById('warning-banner');
    var closeBtn = document.getElementById('warning-banner-close');
    var pairingNotice = document.getElementById('pairing-notice');
    var paperSel = document.getElementById('paper-color');
    if (!banner || !closeBtn) {
      console.error('[warning-banner] elements not found');
      return;
    }

    var activeTab = 'design';
    var isDismissed = sessionStorage.getItem(STORAGE_KEY) === '1';

    function render() {
      if (activeTab === 'info') {
        banner.style.display = 'none';
        return;
      }
      if (isDismissed) {
        banner.style.display = 'none';
        return;
      }
      banner.style.display = 'flex';
    }

    closeBtn.addEventListener('click', function () {
      isDismissed = true;
      sessionStorage.setItem(STORAGE_KEY, '1');
      render();
      console.log('[warning-banner] dismissed for session');
    });

    document.querySelectorAll('.tab-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        activeTab = btn.getAttribute('data-tab');
        render();
      });
    });

    function updatePairingNotice() {
      if (!paperSel || !pairingNotice) return;
      var isBlack = paperSel.value === BLACK_PAPER_VALUE;
      pairingNotice.style.display = isBlack ? 'block' : 'none';
      if (isBlack) {
        console.log('[warning-banner] black paper detected → showing pairing notice');
      }
    }
    if (paperSel) {
      paperSel.addEventListener('change', updatePairingNotice);
      updatePairingNotice();
    }

    render();
  });
})();
